module.exports = __webpack_public_path__ + "img/physics01.7c956279.png";